import useGraphqlClient from '@blueshift-ui/fetch/dist/hooks/use-graphql-client';

export default useGraphqlClient;
